import { render } from "./WonderOfTheWorld.vue?vue&type=template&id=47c9da7c"
import script from "./WonderOfTheWorld.vue?vue&type=script&lang=js"
export * from "./WonderOfTheWorld.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/WonderOfTheWorld.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47c9da7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47c9da7c', __exports__)) {
    api.reload('47c9da7c', __exports__)
  }
  
  module.hot.accept("./WonderOfTheWorld.vue?vue&type=template&id=47c9da7c", () => {
    api.rerender('47c9da7c', render)
  })

}


export default __exports__